import OPTIONS from './cloudinary_options.js';

const cloudinaryBindings = (options => {
  const bindings = {
    publicId: '<',
    container: '<',
    className: '@'
  };

  options.forEach(option => {
    const key = typeof option === 'string' ? option : option.name;

    bindings[key] = '@';
  });

  return bindings;
})(OPTIONS);

export default cloudinaryBindings;
